import {
  QueryFunction,
  QueryKey,
  useMutation,
  useQuery,
  UseQueryOptions
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { clearStorage } from 'features/auth';
import { UserApiService } from 'features/users';
import { queryClient } from 'providers';
import { User } from 'types';

import { userQueryKeys } from './query-keys';

const { getUser, agentEventList, deleteAgentEventList } = UserApiService();

const getUserQuery = (
  id: string,
  options?: UseQueryOptions<User>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<User>;
  options?: UseQueryOptions<User>;
} => ({
  //   queryKey: userQueryKeys.detail(id),
  //   queryFn: ({ signal }) => getUser(id, { config: { signal } }),
  //   ...options,
  // });
  queryKey: userQueryKeys.detail(id),
  queryFn: async ({ signal }) => {
    const response = await getUser(id, { config: { signal } });

    if (response.status === 200) {
      return response.data;
    } else {
      clearStorage();
      queryClient.clear();
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  },
  ...options,
});

export const useGetUser = (id: string, options?: UseQueryOptions<User>) => {
  const { message } = App.useApp();

  return useQuery<User, Error>(
    getUserQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};

interface AgentEventList {
  agent_id: number,
  event_id: number;
  event_name: string;
}


export const useGetAgentEventList = (id: string) => {
  //const { data, error, isLoading } <User[]>
  return useQuery<AgentEventList[]>(['agentEventList', id], () => agentEventList(id), {
    enabled: !!id, // Only fetch data if userId is truthy
  });
};


export const useDeleteAgentEvent = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return deleteAgentEventList(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: (user) => {

        const response: any = user;
        message.success(`${response.ResponseMessage} `);
      },
    },
  );
};



